export default function Footer() {
  return <p className='mt-2 text-xs'>Made with 🧡 by @bordalix</p>
}
